import { FILE_HOST } from '../constants';

export const noop = () => {};

export const formatPrice = (price?: string | number) => {
  if (price !== undefined) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return '';
  }
};

export const formatCancelPrice = (price: number) => {
  return Math.ceil(price / 10) * 10;
};

export const getVoucherLink = (bookingId: string, bookingToken: string) => {
  return `${FILE_HOST}/voucher/${bookingId}/${bookingToken}`;
};

export const base64ToBlob = (base64: string, mime: string) => {
  const bin = atob(base64.replace(/^.*,/, ''));
  const buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  const blob = new Blob([buffer.buffer], { type: mime });
  return blob;
};

export const downloadCSV = (csvBase64: string, fileName: string) => {
  const blob = base64ToBlob(csvBase64, 'text/csv');
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getPathParams = (path: string, searchParams: URLSearchParams) => {
  return `${path}${
    searchParams.toString() ? `?${searchParams.toString()}` : ''
  }`;
};

export const generateId = () => {
  return Math.floor(Math.random() * 1e8).toString();
};
